import { styled } from '@mui/system';
import { colorPalette } from '../../colorPalette';
export const StyledDiv = styled('div')(({ isMobile }) => ({
    display: 'flex',
    borderRadius: !isMobile ? '8px' : 0,
    border: !isMobile ? `1px solid ${colorPalette.gray200}` : 0,
    padding: '16px',
    flexDirection: 'column',
}));
export const displayTitle = () => ({
    color: colorPalette.gray900,
});
export const iconStyle = {
    color: colorPalette.gray700,
    width: 20,
    height: 20,
};
export const headerContainer = {
    color: '#333',
    fontFamily: 'RakutenSansUI',
    fontSize: '1.8rem',
    fontStyle: 'normal',
    display: 'flex',
    fontWeight: 400,
    lineHeight: 'normal',
};
export const iconContainer = {
    backgroundColor: colorPalette.gray100,
    borderRadius: '4px',
    marginRight: '16px',
    height: '32px',
    width: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
export const fadeout = {
    zIndex: '1000',
    width: '-webkit-stretch',
    background: 'linear-gradient(to bottom,rgba(255,255,255,0) 70%,white 100%)',
};
export const moduleContainer = {
    marginTop: '16px',
    display: 'flex',
};
export const moduleContainerDrawer = {
    padding: '16px',
    display: 'flex',
    maxHeight: '80vh',
};
export const moreContainer = {
    marginTop: '16px',
    height: '60px',
};
